(function() {
    angular
        .module("customersModule")
        .controller("CustomerNewController", CustomerNewController)

    CustomerNewController.$inject = [
        "$state",
        "$rootScope",
        "$scope",
        "$window",
        "customersService",
        "userMessagingService"
    ]

    function CustomerNewController(
        $state,
        $rootScope,
        $scope,
        $window,
        customersService,
        userMessagingService
    ){
        "use strict"

        /**
            $rootScope variables
         **/
        $rootScope.title = "New Customer | WANCO"

        /**
            $scope variables
         **/
        $scope.formSuccess     = false
        $scope.formFailure     = false
        $scope.formData        = {}
        $scope.allowSubSection = $rootScope.customers.length > 1

        if (!$rootScope.hasScope('wanco')) {
            $scope.formData.parent_id = $rootScope.selectedCustomerID
        }
        if ($scope.allowSubSection === true) {
            $scope.formData.parent_id = $rootScope.selectedCustomerID
        }

        gtag("event", "create_customer", { action: "begin", parent_id: $scope.formData.parent_id })

        /**
            Create new customer
         **/
        $scope.createCustomer = function() {

            $scope.submitted = true

            if ($rootScope.can('SystemApiConfigCreate')) {
                if (Number($scope.formData.lrpm) === undefined) {
                    $scope.formData.lrpm = 0
                }
                if (Number($scope.formData.lopm) === undefined) {
                    $scope.formData.lopm = 0
                }
                if (Number($scope.formData.rrpm) === undefined) {
                    $scope.formData.rrpm = 0
                }
                if (Number($scope.formData.rdpm) === undefined) {
                    $scope.formData.rdpm = 0
                }
            }

            if ($scope.createCustomerForm.$valid) {

                var success = function(data) {
                    gtag("event", "create_customer", { action: "complete", parent_id: $scope.formData.parent_id, customer_id: data.id })

                    $rootScope.customers = $rootScope.customers.concat([data])

                    $state.go("customers", null, { reload: true }).then(() => {
                        userMessagingService.success("Customer Successfully Created")
                    })
                }

                var failure = function(error) {
                    userMessagingService.error(error)
                }

                customersService.createCustomer(angular.fromJson($scope.formData), success, failure)
            }
        }

        $scope.cancel = () => gtag("event", "create_customer", { action: "cancel", parent_id: $scope.formData.parent_id })

        $scope.skipNonDigits = (event) => {
            if (!event.metaKey && !event.altKey && !event.ctrlKey && isNaN(event.key)) {
                event.preventDefault()
            }
        }
    }
})()
